import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../utils/redux/store";
import { useAppSelector } from "../../utils/redux/hooks";
import { Blog } from "../../types/type";
import { useDispatch } from "react-redux";
import { addisLoading } from "../../utils/redux/mainSlice";
import { deleteBlog, getBlog } from "../../utils/apis/func";
import DeleteModal from "../helpers/blog/DeleteModal";
import PreviewBlog from "../helpers/blog/PreviewBlog";
import PublishModal from "../helpers/blog/PublishFormModal";
import BlogEditor from "../helpers/blog/BlogEditor";

const BlogPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const blogs = useAppSelector((store: RootState) => store.user.blogs);

  const [blog, setBlog] = useState<Blog | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [value, setValue] = useState("");
  const [showPublish, setShowPublish] = useState(false);

  useEffect(() => {
    const getBlogFunc = async () => {
      if (!id) {
        return;
      }
      const res: any = await getBlog(id);

      if (res.status === 201 || res.status === 200) {
        setBlog(res?.data?.data);
      }
      if (res.status === 400) {
        navigate("/blog");
      }
    };
    (async () => {
      try {
        dispatch(addisLoading(true));
        let blogToSet = blogs?.find((blog) => blog._id === id);
        if (blogToSet) {
          setBlog(blogToSet);
        } else {
          await getBlogFunc();
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        dispatch(addisLoading(false));
      }
    })();
  }, [id]);

  useEffect(() => {
    if (blog?.content) setValue(blog?.content);
  }, [blog?.content]);

  const onDeleteModalClose = useCallback(() => {
    setShowDeleteModal(false);
  }, []);

  if (!blog) return <></>;
  return (
    <div>
      <DeleteModal
        isOpen={showDeleteModal}
        onClose={onDeleteModalClose}
        id={id}
      />
      {showPublish && (
        <PublishModal
          setShowPublish={setShowPublish}
          content={value}
          isPublish={false}
          origBlogThumbnail={blog.thumbnail}
          origBlogTitle={blog.title}
          blogId={blog._id}
        />
      )}
      <header className="max-h-max flex justify-between items-center px-4">
        <h3 className="text-xl font-bold mb-4">{blog.title}</h3>
        <div className="[&>button]:font-medium [&>button]:text-xl flex gap-2 [&>button]:px-4 [&>button]:py-2 [&>button]:text-white [&>button]:rounded-[5px] ">
          {editMode ? (
            <>
              <button
                className="bg-[#A8A8A8]"
                onClick={() => setEditMode(false)}
              >
                Cancel
              </button>
              <button
                className="bg-[#88087B]"
                onClick={() => setShowPublish(true)}
              >
                Update
              </button>
            </>
          ) : (
            <>
              <button
                className="bg-[#A8A8A8]"
                onClick={() => setEditMode(true)}
              >
                Edit
              </button>
              <button
                className="bg-[#88087B]"
                onClick={() => setShowDeleteModal(true)}
              >
                Delete
              </button>
            </>
          )}
        </div>
      </header>
      <div className="p-4 px-12">
        {editMode ? (
          <BlogEditor setValue={setValue} value={value} />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: blog?.content }} />
        )}
      </div>
    </div>
  );
};

export default BlogPage;
